module.exports = __webpack_public_path__ + "static/apple-touch-icon-a3027fd7a5d3937439bb52fbe31744eb.png";